import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 18 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 17\" id=\"facebook\"><path d=\"M11.03 15.5v.62h4.2c.77 0 1.4-.62 1.4-1.4V2.28c0-.77-.63-1.4-1.4-1.4H2.76c-.77 0-1.4.63-1.4 1.4v12.46c0 .77.63 1.4 1.4 1.4h8.02V9.04H8.97V8.6H10.79V6.17c0-.73.24-1.18.56-1.46.34-.3.86-.47 1.54-.47h.3v.13h-.49a1.52 1.52 0 0 0-1.5.97c-.17.45-.17.95-.17 1.24V8.6h2.09v.45h-2.09v6.46Z\" stroke=\"currentColor\" stroke-width=\"1.25\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol